var React = require('react');

function DiagonalArrowDesktopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L35.2734 35.2734M35.2734 35.2734V1M35.2734 35.2734H1","stroke":"#2A2A2A","strokeWidth":"0.901931"}));
}

DiagonalArrowDesktopInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = DiagonalArrowDesktopInline;

DiagonalArrowDesktopInline.default = DiagonalArrowDesktopInline;
